import bilAPI from '../api';

export const getInclusivenessDocs = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/core/inclusiveness_docs/', { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postInclusivenessDoc = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/core/inclusiveness_docs/', body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getInclusivenessDoc = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/core/inclusiveness_docs/${uuid}/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchInclusivenessDoc = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/core/inclusiveness_docs/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteInclusivenessDoc = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/core/inclusiveness_docs/${uuid}/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

